<template>
    <div>
        <div class="bg-register" v-if="!isOpenScanQr">
            <div>
                <SwitchLang></SwitchLang>
            </div>
            <div >
                <img class="bhp-logo" src="@/assets/img/bh_logo/bhp-logo-white.svg" alt="">
            </div>
            <div class="bg-form-register">
                <img class="bg-top" src="@/assets/img/bg-white-top.png" alt="">
                <div class="title">{{ lbl.register.title }}</div>
                <div class="form-input" v-if="isLoaded">
                    <InputDropdown
                        v-model="formRegister.type"
                        class="pt-1"
                        :isTextOnly="true"
                        :errorInfo="errorInfo[0]"
                        :isShowError="true"
                        :isSubmitted="isSubmitted"
                        :inputLbl="lbl.register.type"
                        :itemList="lbl.register.id_type"
                        :inputName="'id_type'"
                        @update:inputValue="onSelectType($event)"
                        @selectType="selectType($event)"
                        @onSelectedType="onSelectedType($event)"
                    ></InputDropdown>
                    <InputText
                        v-model="formRegister.name"
                        :isTextOnly="true"
                        :errorInfo="errorInfo[1]"
                        :isShowError="true"
                        :isSubmitted="isSubmitted"
                        :maxLength="50"
                        :inputLbl="lbl.register.firstname"
                        :selectType="inputData"
                        :isShowName="true"
                        :dataFromCache="dataFromCache"
                        :itemList="lbl.register.id_type"
                        @update:inputValue="onNameChange($event)"
                    ></InputText>
                    <InputText
                        v-model="formRegister.no"
                        :isTextOnly="false"
                        :errorInfo="errorInfo[2]"
                        :isShowError="true"
                        :isSubmitted="isSubmitted"
                        :inputLbl="lbl.register.no"
                        :selectType="inputData"
                        delimeter="-"
                        :isShowNo="true"
                        :dataFromCache="dataFromCache"
                        :itemList="lbl.register.id_type"
                        @update:inputValue="onTypeId($event)"
                    ></InputText>
                    <div class="title-gender mb-1">{{ lbl.register.title_gender }}</div>
                    <RadioBox
                        inputId="change-status"
                        :options="genderList"
                        @input="onSelectGender($event)"
                        @onSelectedGender="onSelectedGender($event)"
                    />
                    <InputDropdown
                        v-model="formRegister.race"
                        :isTextOnly="true"
                        :errorInfo="errorInfo[3]"
                        :isShowError="true"
                        :isSubmitted="isSubmitted"
                        :inputLbl="lbl.register.race"
                        :itemList="raceType"
                        :inputName="'race'"
                        :selectedFromCache="raceCache"
                        @selectRace="selectRace($event)"
                        @onSelectedRace="onSelectedRace($event)"
                    ></InputDropdown>
                    <InputDropdownContactNumber
                        v-model="formRegister.contactNumber"
                        :isTextOnly="false"
                        :errorInfo="errorInfo[4]"
                        :isShowError="true"
                        :isSubmitted="isSubmitted"
                        :inputLbl="lbl.register.contactNumber"
                        :itemList="lbl.register.flag"
                        :selectedFromCache="countryCodeCache"
                        @update:inputValue="onContactNumber($event)"
                        @countryCode="onCountryCode($event)"
                    ></InputDropdownContactNumber>
                    <InputEmail
                        v-model="formRegister.email"
                        :isTextOnly="false"
                        :errorInfo="errorInfo[5]"
                        :isShowError="true"
                        :isSubmitted="isSubmitted"
                        :inputLbl="lbl.register.email"
                        @update:inputValue="onEmailChange($event)"
                    ></InputEmail>
                    <InputPassword
                        :inputId="'input_pass'"
                        v-model="formRegister.password"
                        :isTextOnly="false"
                        :errorInfo="errorInfo[6]"
                        :isShowError="true"
                        :minLength="6"
                        :maxLength="16"
                        :isSubmitted="isSubmitted"
                        :isPassword="true"
                        :inputLbl="lbl.register.password"
                        :isRemoveThai="true"
                        @update:inputValue="onPasswordChange($event)"
                    ></InputPassword>
                    <InputPassword
                        :inputId="'input_confrim_pass'"
                        v-model="formRegister.confirmPassword"
                        :isTextOnly="false"
                        :errorInfo="errorInfo[7]"
                        :isShowError="true"
                        :isSubmitted="isSubmitted"
                        :minLength="6"
                        :maxLength="16"
                        :isConfirmPassword="true"
                        :passWord="formRegister.password"
                        :inputLbl="lbl.register.confirm_password"
                        :isRemoveThai="true"
                        @update:inputValue="onConfirmPassword($event)"
                    ></InputPassword>
                    <div class="box-referral">
                        <div class="title-refer">{{ lbl.register.text_refer }}</div>
                        <InputText
                            v-model="formRegister.referFriend"
                            :isTextOnly="false"
                            :errorInfo="errorInfo[8]"
                            :isShowError="true"
                            :isSubmitted="isSubmitted"
                            :inputLbl="lbl.register.refer_friend"
                            :refCode="referalCode"
                            :maxLength="20"
                            @update:inputValue="onReferFriendChange($event)"
                        ></InputText>
                        <div class="line-custom"></div>
                        <div class="box-scan">
                            <img @click="onClickScanQr()" src="@/assets/icon/ic-scan.svg" alt="">
                        </div>
                    </div>
                    <div class="accept-term">
                        <CheckBox v-model="formRegister.isAcceptTerms" @update:check="onCheckTerms($event)"></CheckBox>
                        <div class="ml-2">
                            {{ lbl.register.pdpa.agree }}
                            <span class="text-terms" @click="onClickTermPrivacy('terms')">{{ lbl.register.pdpa.terms }}</span>
                            <span>{{ lbl.register.pdpa.and }}</span>
                            <span class="text-terms" @click="onClickTermPrivacy('privacy')">{{ lbl.register.pdpa.privacy }}</span>
                        </div>
                    </div>
                </div>
                <div class="btn" v-if="validateInputForm()" @click="clickRegister()">
                    <OrangeButton :textBtn="lbl.register.btn" ></OrangeButton>
                </div>
                <div class="btn" v-else><GrayButton :textBtn="lbl.register.btn"></GrayButton></div>
            </div>
        </div>
        <div v-else>
            <ScanQr 
                @onDataQrCode="onDataQrCode($event)" 
                @onCloseCamera="onClickScanQr($event)"
            ></ScanQr>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import Vue from 'vue';
import { FormHelper } from '@/helper/FormHelper';
import Account from '@/helper/AccountHelper.js';
import Util from '@/helper/Utility.js';
import Locale from '@/helper/locale/locale.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import SwitchLang from '../component/SwitchLang.vue';
import ScanQr from "../component/ScanQr.vue";
import InputDropdown from '@/components/Input/InputDropdown.vue';
import InputText from '@/components/Input/InputText.vue';
import RadioBox from "@/components/Input/RadioBox.vue";
import InputDropdownContactNumber from '@/components/Input/InputDropdownContactNumber.vue';
import InputEmail from '@/components/Input/InputEmail.vue';
import InputPassword from '@/components/Input/InputPassword.vue'
import CheckBox from "@/components/Input/CheckBox.vue";
import OrangeButton from "@/components/Button/OrangeButton.vue";
import GrayButton from '@/components/Button/GrayButton.vue';

import RegisterService from '../service/RegisterService.js';

import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";
export default {
    name: 'register',
    components: {
        SwitchLang,
        ScanQr,
        InputDropdown,
        InputText,
        RadioBox,
        InputDropdownContactNumber,
        InputEmail,
        InputPassword,
        CheckBox,
        OrangeButton,
        GrayButton,
        ModalMaster,
    },
    mixins: [LocaleMixin],
    data: function() {
        return {
            lbl: Locale.getLbl(),
            isLogin: false,
            objProfile: {},
            errorInfo: FormHelper.genErrorInfo(9),
            isSubmitted: false,

            formRegister: {
                type: '',
                name: '',
                no: '',
                race: '',
                contactNumber: '',
                email: '',
                password: '',
                confirmPassword: '',
                language: '',
                referFriend: '',
                isAcceptTerms: false,
                birthdate: null,
                gender: 'male',
                countryCode: 60
            },
            genderList: [],
            raceType: [],
            selected: true,
            inputData: '',
            referalCode: '',
            checkAlphabet: '',
            saveCacheFormData: {},
            saveCacheFormForShowData: {},
            isValidForm: false,
            countryCodeCache: null,
            typeCache: null,
            genderCache: {},
            raceCache: null,
            saveData: null,
            dataFromCache: null,
            referalCodeCache: null,

            modalController: null,
            alertModal: null,
            loadingModal: null,
            termsModal: null,

            isLoaded: false,
            isOpenScanQr: false,
            refCodeQr: null
        };
    },
    created: async function() {

        let modalFactory = new ModalFactory();
        this.modalController = modalFactory.getModalController();
        this.alertModal = modalFactory.getAlertModal();
        this.loadingModal = modalFactory.getLoadingModal();
        this.termsModal = modalFactory.getTermsModal();
        await this.getRaceBlob();
        
        this.genderList =  [
            { value: 'male', text: this.lbl.register.male, default: true },
            { value: 'female', text: this.lbl.register.female, default: false },
        ]

        this.genderCache = [{ value: 'male', text: this.lbl.register.male, default: true }]
        if (this.referalCode == '') {
            this.getReferalCodeBlob();
        } else {
            this.restoreForm();
        }
        this.isLoaded = true;

        Account.loginStatus().then((status) => {
            this.isLogin = status;
            this.objProfile = Account.getCacheProfile();
        });
    },
    methods: {
        logout: function() {
            Account.setLogout();
            this.isLogin = false;
            this.objProfile = {};
        },

        getRaceBlob: async function () {
            try {
                let res = await RegisterService.apiGetRaceBlob();
                if (res) {
                    
                    this.raceType = res.data[this.localeCode];
                    await this.restoreForm();

                } else {
                    throw res;
                }
            } catch (ex) {
                console.log("ex", ex);
                // this.errorHandle(ex);
            }
        },
        getReferalCodeBlob: async function () {
            try {
                let res = await RegisterService.apiGetReferralCodeBlob();
                if (res) {

                    this.referalCode = res.data.referral_code;
                } else {
                    throw res;
                }
            } catch (ex) {
                console.log("ex", ex);
                // this.errorHandle(ex);
            }
        },
        onDataQrCode: function (code) {
            this.formRegister.referFriend = code;
            this.referalCode = code;
            this.saveCacheFormData = this.genDataToSaveCache();
            this.saveCacheForm();
        },
        selectType:function (data) {
            this.formRegister.type = data;
        },
        onSelectType: function (selectedType) {
            this.inputData = selectedType;
        },
        onSelectedType: function (selectedType) {
            this.typeCache = selectedType;
            this.saveCacheFormData = this.genDataToSaveCache();
            this.saveCacheForm();
        },
        onSelectGender: function (gender) {
            if (gender) {
                this.formRegister.gender = 'male'
            } else {
                this.formRegister.gender = 'female';
            }
            this.saveCacheFormData = this.genDataToSaveCache();
            this.saveCacheForm();
        },
        onSelectedGender: function (gender) {
            this.genderCache = gender;
            this.saveCacheFormData = this.genDataToSaveCache();
            this.saveCacheForm();
        },
        selectRace: function (race) {
            this.formRegister.race = race;
        },
        onSelectedRace: function (race) {
            this.raceCache = race;
            this.saveCacheFormData = this.genDataToSaveCache();
            this.saveCacheForm();
        },
        onNameChange: function (infoName) {
            this.formRegister.name = infoName;
            this.saveCacheFormData = this.genDataToSaveCache();
            this.saveCacheForm();
        },
        onTypeId: function (id) {
            if (this.formRegister.type == "NRIC" ) {
                this.checkFormatNric(id);
                this.formRegister.no = id;
            } else {
                this.formRegister.no = id;
            }
            this.saveCacheFormData = this.genDataToSaveCache();
            this.saveCacheForm();
        },
        checkFormatNric: function (id) {
            const subData = id.substr(0,6);
            let year = subData.substr(0,2);
            let month = subData.substr(2,2);
            let day = subData.substr(4,6);
            let prefix = null;
            let birthdate = null;
            let lastday = null;
            if (year >= 0 && year <= 30) {
                prefix = 20;
            } else {
                prefix = 19;
            }
            if (month > 12) {
                month = 12;
            }
            const checkYear = prefix + year;
            lastday = this.checkLastday(checkYear, month);
            if (day > lastday) {
                day = lastday;
            }

            birthdate = `${checkYear}-${month}-${day}`;
            this.formRegister.birthdate = Date.parse(birthdate);
        },
        checkLastday: function(y,m){
            return  new Date(y, m, 0).getDate();
        },
        onContactNumber: function (tel) {
            this.formRegister.contactNumber = tel;
            this.saveCacheFormData = this.genDataToSaveCache();
            this.saveCacheForm();
        },
        onCountryCode: function (code) {
            if (code == 'malaysia') {
                this.formRegister.countryCode = 60;
            } else {
                this.formRegister.countryCode = 65;
            }
            this.saveCacheFormData = this.genDataToSaveCache();
            this.saveCacheForm();
        },
        onEmailChange: function (email) {
            this.formRegister.email = email;
            this.saveCacheFormData = this.genDataToSaveCache();
            this.saveCacheForm();
        },
        onPasswordChange: function (pass) {
            this.formRegister.password = pass;
            this.saveCacheFormData = this.genDataToSaveCache();
            this.saveCacheForm();
        },
        onConfirmPassword: function (conPass) {
            this.formRegister.confirmPassword = conPass;
            this.saveCacheFormData = this.genDataToSaveCache();
            this.saveCacheForm();
        },

        onReferFriendChange: function (refer) {
            this.formRegister.referFriend = refer;
            this.referalCode = refer;
            this.saveCacheFormData = this.genDataToSaveCache();
            this.saveCacheForm();
        },

        clickRegister: async function() {
            const valid = this.validateForm();
            if (valid) {
                let data = null;
                this.loadingModal.show();
                data = await this.genFormData();
                this.saveCacheFormData = this.genDataToSaveCache();
                this.saveCacheForm();
                try {
                    let res = await RegisterService.apiVerifyRegister(data);
                    if (res) {
                        this.saveCacheFormData.expiredate = res.data.expiredate
                        this.saveCacheFormData.refcode = res.data.refcode
                        this.saveCacheForm()
                        this.$router.push("/register/otp");
                        //route to otp
                    } else {
                        throw res;
                    }
                } catch (ex) {
                    console.log("ex", ex.response.data.error);
                    this.loadingModal.hide();
                    this.errorHandle(ex.response.data.error);
                }
            }

            this.loadingModal.hide();
        },
        genFormData: function() {
            if (this.localeCode == '1033') {
                this.formRegister.language = 'English';
            } else if (this.localeCode == '1086') {
                this.formRegister.language = 'Malaysia';
            } else {
                this.formRegister.language = 'Chinese';
            }
            let personalId = '';
            if ((this.formRegister.type == 'NRIC') && this.formRegister.no != '') {
                let id = this.formRegister.no.split('-');
                personalId = id[0]+id[1]+id[2];
            } else {
                personalId = this.formRegister.no;
            }
            const data = {
                personal_id: personalId,
                contact_number: this.formRegister.contactNumber,
                country_code: this.formRegister.countryCode,
                language: this.formRegister.language,
                username: this.formRegister.contactNumber,
                email: this.formRegister.email,
                referral_code: this.formRegister.referFriend,
            }
            return data;
        },
        validateInputForm: function (){
            if(Util.isEmptyStr(this.formRegister.type) ||
                Util.isEmptyStr(this.formRegister.name) ||
                Util.isEmptyStr(this.formRegister.no) ||
                Util.isEmptyStr(this.formRegister.race) ||
                Util.isEmptyStr(this.formRegister.contactNumber) ||
                Util.isEmptyStr(this.formRegister.email) ||
                Util.isEmptyStr(this.formRegister.password) ||
                Util.isEmptyStr(this.formRegister.confirmPassword) ||
                (!this.formRegister.isAcceptTerms)
                
            ){
                return false;
            }else{
                return true;
            }
        },
        validateForm: function() {
            var form = this.formRegister;
            if (this.formRegister.type == "NRIC") {
                if (form.no.length < 12) {
                    this.showAlert(this.formRegister.type, this.formRegister.type);
                    return false;
                }
            }
            if (this.formRegister.type == "Passport") {
                const check = form.no.charAt(0);
                this.checkAlphabet = check.replace(Vue.RegExp.alphabetForIdType, "");
                if (this.checkAlphabet == '' || (form.no.length <= 1 || form.no.length < 9)) {
                    this.showAlert(this.formRegister.type, this.formRegister.type);
                    return false;
                }
            }
            if (this.formRegister.type == "Army ID" || this.formRegister.type == "Police ID") {
                const check = form.no.charAt(0)
                const checkId = form.no.substr(length-4);
                const checkNumber = checkId.replace(Vue.RegExp.notNumber, "");
                this.checkAlphabet = check.replace(Vue.RegExp.alphabetForIdType, "");
                if (this.checkAlphabet == '' || form.no.length < 5 || checkNumber.length != 4) {
                    this.showAlert(this.formRegister.type, this.formRegister.type);
                    return false;
                }
            }
            if (form.contactNumber) {
                const check = form.contactNumber.charAt(0)
                if (check == 0 && (form.contactNumber.length != 11 && form.contactNumber.length != 10)) {
                    this.showAlert('', this.lbl.register.valid_mobile);
                    return false;
                } else if ((check == 8 || check == 9) && form.contactNumber.length != 8) {
                    this.showAlert('', this.lbl.register.valid_mobile);
                    return false;
                }
            }
            if (!Util.validateEmail(form.email)) {
                this.showAlert('',this.lbl.register.valid_email);
                return false;
            }
            if (this.formRegister.password) {
                if (this.formRegister.password.length < 6 || this.formRegister.password.length  > 16) {
                    this.alertModal
                            .clearText()
                            .setTitle(this.lbl.register.error.title)
                            .setMsg(this.lbl.register.validate.password)
                            .setBtnOk(this.lbl.register.validate.btn)
                            .setTag("Invalid")
                            .show();
                    return false;
                }
                if (this.formRegister.password != this.formRegister.confirmPassword) {
                    this.alertModal
                            .clearText()
                            .setTitle(this.lbl.register.error.title)
                            .setMsg(this.lbl.register.validate.not_match)
                            .setBtnOk(this.lbl.register.validate.btn)
                            .setTag("Invalid")
                            .show();
                    return false;
                }
            }
            return true;
        },
        // onFormChange: function (data) {
        //     this.inputData = data;
        // },
        genDataToSaveCache: function () {
            const saveData = {
                username: this.formRegister.contactNumber || '',
                personal_id_type: this.typeCache || '',
                personal_id: this.formRegister.no || '',
                contact_number: this.formRegister.contactNumber || '',
                country_code: this.formRegister.countryCode || '',
                email: this.formRegister.email || '',
                password: this.formRegister.password || '',
                fullname: this.formRegister.name || '',
                nameOnCard: this.formRegister.name || '',
                language: this.formRegister.language || '',
                race: this.raceCache,
                birthdate: this.formRegister.birthdate || '',
                referralcode: this.referalCode || '',
                gender: this.genderCache || ''
            };
            return saveData
        },
        saveCacheForm: function () {
            window.sessionStorage.setItem('form_register', JSON.stringify(this.saveCacheFormData));
        },
        restoreForm: async function () {
            let cache = window.sessionStorage.getItem('form_register')
            let getCache = JSON.parse(cache)
            
            if (getCache != null) {
                let personal_id_type = this.lbl.register.id_type.filter((item) => {
                    return item.value == getCache.personal_id_type.value;
                })
                this.typeCache = personal_id_type[0];
                this.formRegister.type = personal_id_type[0].value;
                this.dataFromCache = personal_id_type[0];

                this.formRegister.name = getCache.fullname;
                this.formRegister.no = getCache.personal_id;

                if ((getCache.gender && getCache.gender[0] && getCache.gender[0].value == 'male') 
                    || getCache.gender.value == 'male' || getCache.gender.value == 'Male') {
                     this.genderList =  [
                        { value: 'male', text: this.lbl.register.male, default: true },
                        { value: 'female', text: this.lbl.register.female, default: false },
                    ]
                    this.genderCache = getCache.gender;
                    this.formRegister.gender = getCache.gender;
                } else {
                    this.genderList =  [
                        { value: 'male', text: this.lbl.register.male, default: false },
                        { value: 'female', text: this.lbl.register.female, default: true }
                    ]
                    this.genderCache = getCache.gender;
                    this.formRegister.gender = getCache.gender;
                }

                let raceTypeInfo = await this.raceType.filter((item) => {
                    return item.value == getCache.race.value;
                })
                this.raceCache = raceTypeInfo[0];
                this.formRegister.race = raceTypeInfo[0].value;
                this.formRegister.contactNumber = getCache.contact_number;

                if (getCache.country_code == 60 || getCache.country_code == 'malaysia') {
                    this.formRegister.countryCode = 'malaysia';
                } else {
                    this.formRegister.countryCode = 'singapore';
                }
                let flag = this.lbl.register.flag.filter((item) => {
                    return item.text == this.formRegister.countryCode;
                })
                if (this.formRegister.countryCode == 'malaysia') {
                    this.formRegister.countryCode = 60;
                } else {
                    this.formRegister.countryCode = 65;
                }
                this.countryCodeCache = flag;
                this.formRegister.email = getCache.email;
                this.formRegister.password = getCache.password;
                this.formRegister.confirmPassword = getCache.password;
                this.formRegister.referFriend = getCache.referralcode;
                this.referalCode = getCache.referralcode;
                this.formRegister.isAcceptTerms = true;
            }
            return getCache
        },
        onCheckTerms: function (accept) {
            if (accept) {
                this.formRegister.isAcceptTerms = true;
            } else {
                this.formRegister.isAcceptTerms = false;
            }
            window.sessionStorage.setItem('accept_terms_privacy', accept)
            return false;
        },
        onClickTermPrivacy: function (type) {
            this.termsModal
                .clearText()
                .setTag(type)
                .setBtnOk(this.lbl.default.close)
                .show()
        },
        onClickScanQr: function (close) {
            if (close) {
                this.isOpenScanQr = false;  
            } else {
                this.isOpenScanQr = true;
            }
        },
        showAlert: function(type, strMessage) {
            if (type != '') {
                this.alertModal
                        .clearText()
                        .setTitle(this.lbl.register.error.title)
                        .setMsg(Util.stringFormat(this.lbl.register.validate.input_id, this.typeCache.text, this.typeCache.text))
                        .setBtnOk(this.lbl.register.validate.btn)
                        .setTag("Invalid")
                        .show();
            } else {
                this.alertModal
                    .clearText()
                    .setTitle(this.lbl.register.error.title)
                    .setMsg(Util.stringFormat(this.lbl.register.validate.input_invalid, strMessage))
                    .setBtnOk(this.lbl.register.validate.btn)
                    .setTag("Invalid")
                    .show();
            }
        },
        errorHandle: function(exception) {
            let title = this.lbl.register.error.title;
            let body = ``;
            if (exception) {
                let id = exception.id;
                let code = exception.code;
                let msg = exception.message;
                if (code == 409) {
                    if (id == 2128) {
                        if (msg == "Personal ID Registered") {
                            body = this.lbl.register.error.err_id.msg;
                        } else if (msg == "Contact Number Registered") {
                            body = this.lbl.register.error.err_number.msg;
                        } else if (msg == "Contact Number & Personal ID Registered") {
                            body = this.lbl.register.error.err_number.msg;
                        } 
                    } else if (id == 2089) {
                        if (msg == "DuplicateEmail") {
                            body = this.lbl.register.error.err_dup_email.msg;
                        }
                    } else if (id == 409) {
                        if (msg == "ReferralCode Fully Claimed") {
                            body = this.lbl.register.error.err_refcode_full.msg;
                        } else if (msg == "Invalid ReferralCode") {
                            body = this.lbl.register.error.err_invalid_refcode.msg;
                        }
                    }
                } else {
                    body = msg;
                }
            this.alertModal
                .clearText()
                .setTitle(title)
                .setMsg(body)
                .setBtnOk(this.lbl.register.validate.btn)
                .setTag("error-info")
                .show();
            }
        },
    },
}
</script>
<style lang="scss" scoped>
@import "../style/Register.scss";
</style>
